import {Button} from '../../components/Button';

interface EmptyTripsStateProps {
  onCreateTrip: () => void;
  isCreatingTrip?: boolean;
}

/**
 * Empty state component shown when user has no trips yet.
 */
export const EmptyTripsState = ({ onCreateTrip, isCreatingTrip }: EmptyTripsStateProps) => {
  return (
    <div className="text-center py-20">
      <div className="mx-auto h-24 w-24 text-disabled">
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <h3 className="mt-2 text-sm  text-main">No trips yet</h3>
      <p className="mt-1 text-sm text-muted">Get started by creating a new trip.</p>
      <div className="mt-6">
        <Button
          variant="primary"
          onClick={onCreateTrip}
          disabled={isCreatingTrip}
          loading={isCreatingTrip}
        >
          Create Trip
        </Button>
      </div>
    </div>
  );
};
